module.exports = __webpack_public_path__ + "static/media/qr-code.5d7a660e.svg";